// Shared mutable state for the currently open create/edit/delete dialog.
// A single plain object (not per-dialog state) because only one dialog is
// ever open at a time - handlers across files read/write the same context.
export const currentContext = { id: null, mappingId: null, date: null };
